import BrandIcon from "components/Frontend/Icon/BrandIcon";
import React from "react";
import {
  Container,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";

function NavbarFrontend() {
  return (
    <div>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        fixed="top"
        className="navbar-content"
      >
        <Container>
          <Navbar.Brand href="/home">
            <BrandIcon />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className=" nav-position">
              <Link to="/tutorial" className="nav-link">
                Tutorial
              </Link>

              <Link to="/project" className="nav-link">
                Project
              </Link>
              
              <NavDropdown
                title="Dropdown"
                id="collasible-nav-dropdown"
                className=""
              >
                <NavDropdown.Item href="action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav>
              
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default NavbarFrontend;
